import { Group } from "@mantine/core"
import { SUBSCRIPTION_CATEGORY } from '../../../helpers/subscriptionFeatureAccess';

// Colors are keyed by tier `category` (#2470), not the plan's display `name`, so a
// custom-named plan on one of these three base tiers still gets the right badge color.
const CATEGORY_COLORS = {
  [SUBSCRIPTION_CATEGORY.STARTER]: { background: '#E3E3FC', text: '#5555FF' },
  [SUBSCRIPTION_CATEGORY.PREMIUM]: { background: '#5555FF', text: 'white' },
  [SUBSCRIPTION_CATEGORY.PROFESSIONAL]: { background: '#5041BC', text: 'white' },
};

const SubscriptionBadgeIcon = ({name='Starter', category=SUBSCRIPTION_CATEGORY.STARTER, onClick=null}) => {
  const colors = CATEGORY_COLORS[category] || CATEGORY_COLORS[SUBSCRIPTION_CATEGORY.PROFESSIONAL];
  return (
    <Group onClick={onClick} className="subscription-badge-icon" justify='center' style={{backgroundColor: colors.background}}>
        <span style={{color: colors.text}}>{name}</span>
    </Group>
  );
}

export default SubscriptionBadgeIcon;
